/// <reference path='../../interfaces/interfaces.d.ts' />

'use strict';

class ToggleSidebarDirective {

    public restrict;
    public scope;

    constructor() {
        this.restrict = 'A';
        this.scope = false;
    }

    public link = (scope: ng.IScope, elem: ng.IAugmentedJQuery) => {
        elem.bind('click', () => {
            $('body').toggleClass('mini-leftbar');
        });
    };

    public static DirectiveFn(): any {
        return new ToggleSidebarDirective();
    }

}

angular.module('beneple.global')
    .directive('toggleSidebar', ToggleSidebarDirective.DirectiveFn);



// WEBPACK FOOTER //
// ./frontend/scripts/global/directives/toggle_sidebar.directive.ts